import { GET_COMPANY, SHOW_COMPANY } from "@/store/modules/mutation-types";

export default {
  state: {},
  getters: {},
  actions: {
    async [GET_COMPANY]({ dispatch }, params) {
      const res = await dispatch("apiGet", {
        url: "/kanri/companies",
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    },
    async [SHOW_COMPANY]({ dispatch }, params) {
      let url = "/kanri/companies/" + params.id;
      const res = await dispatch("apiGet", {
        url: url,
        data: params.data
      });
      if (res.status !== 200 && res.status !== 204) {
        throw {
          status: res.status
        };
      }
      return res.data;
    }
  },
  mutations: {}
};
